module.exports = __webpack_public_path__ + "static/media/bottled_cocktails.eceb4f69.jpg";